export * from "./phone-number.directive";
export * from "./input-name.directive";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/directives/index.ts